import {uniqueUuid} from "@vesta/unique/unique";

// TODO: Break this region into two?
// TODO: Stop using regions, and instead document each key separately
// #region Details about the user. Might need revalidation if we update user details, user joins a new company, user creates a new company, or something similar.
export const USER__HEIMDALL_USER__QUERY_KEY = uniqueUuid`940a230a-0a4d-4023-b908-534fcad55b18`;
export const ANANKE__PREFERENCES__QUERY_KEY = uniqueUuid`ee8dcabb-899f-4e0f-8494-3cc9b2a80948`;
export const USER__PROFILE_DETAILS__QUERY_KEY = uniqueUuid`a6159907-33e5-42a0-a4d5-a37d7c0146c0`;
export const USER__ACCESSIBLE_WORKSPACES__QUERY_KEY = uniqueUuid`027f3b96-6008-420d-bf62-351ad74de9f5`;
export const USER__PLATFORM_AUTHORIZATION_DETAILS__QUERY_KEY = uniqueUuid`ac04ac1b-8fb1-4dd4-aa85-4f273e21841e`;
export const USER__PLATFORM_ACCESS_MATRIX__QUERY_KEY = uniqueUuid`585834d3-490c-4b3a-9190-f9e2c17c633d`;
export const USER__WORKSPACE_ACCESS_MATRIX__QUERY_KEY = uniqueUuid`f7b4c2d8-6a91-4e53-8c07-1d9f2a6b5e84`;
export const USER__WORKSPACE_CAPABILITY_ACCESS_MATRIX__QUERY_KEY = uniqueUuid`d9f6e2b8-4c73-5a01-8e25-3b7d9f6c8a14`;
export const IMPERSONATION_USER_ROWS_QUERY_KEY = uniqueUuid`af6a0d45-734f-4eb8-9a8f-15bdb7fc4bb0`;
// export const USER__ACCESS_LEVEL_ON_WORKSPACE__QUERY_KEY = uniqueUuid`62b01a6c-83a0-409d-b81f-06522b5f4427`;
// #endregion

export const WORKSPACE__USERS__PLATFORM_DETAILS__QUERY_KEY = uniqueUuid`b5baabae-194d-42c9-9faa-523c66f44661`;
export const WORKSPACE__USERS__QUERY_KEY = uniqueUuid`ea60c2e5-dafa-4cf6-8f18-f9a2f6db8cec`;
export const WORKSPACE__COMBINED_USERS__QUERY_KEY = uniqueUuid`ee4ea41d-5c77-4fa0-8975-8635ea1b4b6f`;
export const WORKSPACE__USERS__DATA_VIEWER_QUERY_KEY_PREFIX = [uniqueUuid`cf964ab4-83db-4b25-8d92-84e0edd6b5a6`];
export const WORKSPACE__USER_INVITES__DATA_VIEWER_QUERY_KEY_PREFIX = [uniqueUuid`6e2959c3-84e1-4769-b22f-fc5e8b8e28de`];
export const WORKSPACE__BTL_TEMPLATES__QUERY_KEY = uniqueUuid`d0ae7d06-afdd-4273-b343-7a0c5bc61c47`;
export const WORKSPACE__BTL_ACTIVITIES__QUERY_KEY = uniqueUuid`3cd86884-8261-4187-9564-4ea4b56adf63`;
export const WORKSPACE__DOMAIN_AGGREGATE_TEMPLATES__QUERY_KEY = uniqueUuid`a8c4e1b2-6d28-4f90-8c15-2e9b4a6d0f31`;
export const WORKSPACE__USER_DEFINED_OBJECT_TEMPLATES__QUERY_KEY = uniqueUuid`b2bb3098-fca9-4ce3-8b51-35bfedae9e1c`;
export const WORKSPACE__USER_DEFINED_OBJECTS__QUERY_KEY = uniqueUuid`ab200ba6-9153-4664-bf25-83155933e46f`;
export const WORKSPACE__USERS__COUNT__QUERY_KEY = uniqueUuid`22d5f0ce-598a-463b-9b6f-1e4140749b04`;
export const WORKSPACE__USERS__COLUMN_VALUES__QUERY_KEY = uniqueUuid`1fd97a3b-252f-4fcb-b47f-348e372d97ba`;
export const WORKSPACE__USER_TEMPLATES__QUERY_KEY = uniqueUuid`9ef98a26-064f-4fcc-ac29-e8b786ecdda5`;
export const WORKSPACE__PRODUCT_CATALOGUE_TEMPLATES__QUERY_KEY = uniqueUuid`3f7a1b2c-4d5e-6f70-8901-abcdef234567`;
export const WORKSPACE__PRODUCT_CATALOGUES__QUERY_KEY = uniqueUuid`4e8b2c3d-5f6a-7b80-9012-bcdef3456789`;
export const WORKSPACE__PRODUCT_INVENTORIES__QUERY_KEY = uniqueUuid`5f9c3d4e-6a7b-8c90-1234-cdef04567890`;
export const WORKSPACE__ORGANIZATION_UNITS__QUERY_KEY = uniqueUuid`2efe4897-f3f7-4a3f-9417-e6b130abe52b`;
export const WORKSPACE__ORGANIZATION_UNIT_TEMPLATES__QUERY_KEY = uniqueUuid`0f75bfed-cb23-4f02-b104-2e2939b367f3`;
export const WORKSPACE__CAPABILITIES__QUERY_KEY = uniqueUuid`2980e64f-475d-4c5f-aa77-79878e41a2fe`;
export const WORKSPACE__DATASETS__QUERY_KEY = uniqueUuid`7a031a2d-9f12-492c-80cb-db0e39bbf1af`;
export const WORKSPACE__DATASET_DETAILS__QUERY_KEY = uniqueUuid`49b3a0da-9c07-4912-878b-f0ae191c9195`;
export const WORKSPACE__UI_CONFIGS__QUERY_KEY = uniqueUuid`c668e463-9033-4ed3-990d-cf803e7aa958`;
export const WORKSPACE__SUBSCRIPTION_DETAILS__QUERY_KEY = uniqueUuid`97b575b6-e2b0-461a-b0cc-c6d78307544d`;
export const WORKSPACE__RESOURCE_INFORMATION__QUERY_KEY = uniqueUuid`4e6dcdc4-450d-4798-9043-f97ca2ad4421`;
export const WORKSPACE__IS_ANOTHER_PLAN_UPCOMING__QUERY_KEY = uniqueUuid`cbecbdf1-f1a5-4db8-bd70-1681bb668188`;
export const WORKSPACE__INVOICES__QUERY_KEY = uniqueUuid`26c3df56-dc65-4ef1-aee4-4bddb4528f54`;
export const WORKSPACE__INVITES__QUERY_KEY = uniqueUuid`1a2b3c4d-5e6f-7a80-9012-bcdef1234567`;
export const WORKSPACE__INVITES__COUNT__QUERY_KEY = uniqueUuid`e92d0e02-b552-4b45-9b0c-e9012c01c937`;
export const WORKSPACE__INVITES__COLUMN__VALUES__QUERY_KEY = uniqueUuid`75b9d2bf-98cc-4e37-a377-d8cd61461d55`;
export const WORKSPACE__INVITES__DATA__QUERY_KEY = uniqueUuid`e787504f-1598-482f-a4e6-13df14c35514`;
// export const MEDIA__QUERY_KEY = uniqueUuid`dd06c3dc-b735-47d4-bd3c-fb72346915ea`;

export const REPORT__DETAILS__QUERY_KEY = uniqueUuid`f7e43931-39d5-43b7-b6a0-00c51e301f30`;

// export const COLLECTIONS__ALL_METADATA__QUERY_KEY = uniqueUuid`6b65f00b-b626-440c-9c9e-2d3989574f88`;

// export const COLLECTIONS__METADATA__QUERY_KEY = uniqueUuid`6b65f00b-b626-440c-9c9e-2d3989574f88`;

export const WIDGET__TEMPLATES__QUERY_KEY = uniqueUuid`654ba4a5-40ac-41c8-91c2-1629c3195373`;

export const DABBEWALAS__QUERY_KEY = uniqueUuid`c6d79cca-59b8-4243-bcc5-e0f775db7a76`;
export const USER__NOTIFICATIONS__QUERY_KEY = uniqueUuid`c37d4402-d854-40d0-bbe3-581047d29e9c`;

export const WORKSPACE__DETAILS__QUERY_KEY = uniqueUuid`845050df-7a47-426c-b714-64e39a872331`;

export const ADGPT__CHATS__TITLE__QUERY_KEY = uniqueUuid`fef5e3cc-e04e-4399-b97d-b0e32e1558b8`;
export const ADGPT__OPTIMISTIC_CHAT_TITLES__QUERY_KEY = uniqueUuid`af14336a-20d1-4516-bafd-ec80988666ba`;
export const ADGPT__DATASETS__QUERY_KEY = uniqueUuid`a3f8b2c1-4d5e-6789-abcd-ef0123456789`;

export const ANALYTICAL_ENGINE_DATASETS_QUERY_KEY = uniqueUuid`d9b8a7c6-5e4f-4321-9a8b-7c6d5e4f3210`;
export const ANALYTICAL_ENGINE_DATASET_DETAILS_QUERY_KEY = uniqueUuid`e8c7b6a5-4d3f-4210-8b9a-6c5d4e3f2101`;
export const ANALYTICAL_ENGINE_DISTINCT_VALUES_QUERY_KEY = uniqueUuid`f7d6c5b4-3a2e-4109-8c7b-5d4e3f2a1098`;
export const ANALYTICAL_ENGINE_DATA_QUERY_KEY = uniqueUuid`a6b5c4d3-2e1f-4098-7b6c-5d4e3f2a1098`;

// // export const COLLECTIONS__REPORTS__QUERY_KEY = uniqueUuid`6f364c1f-6322-436c-aea6-68a811731b54`;

// export const ALL_REPORT_TEMPLATES_METADATA__QUERY_KEY = uniqueUuid`96b0e411-aec0-4c01-a9b0-b2a5767b673a`;

// // #region Public thingies - typically should never require revalidation
export const COUNTRIES__QUERY_KEY = uniqueUuid`23079bcb-5967-4f77-85e3-823e29a26c82`;
export const INDIA_CITIES__QUERY_KEY = uniqueUuid`9bfc9add-bae7-451d-bd4d-53ad75a69fec`;
export const INDIA_PINCODES__QUERY_KEY = uniqueUuid`ad168bb8-3474-4321-8ee1-fabaedd6dfbe`;
export const INDIA_STATES__QUERY_KEY = uniqueUuid`226c4539-77e9-4381-947b-cab716a75e72`;
export const INDIA_ZONES__QUERY_KEY = uniqueUuid`e923e79c-acf8-42ba-a94a-14666fd2e97d`;
export const TIME_ZONES__QUERY_KEY = uniqueUuid`efbc054b-3c2c-4471-9f72-73cf8c1e1849`;
export const PUBLIC_SUBSCRIPTION_PLANS__QUERY_KEY = uniqueUuid`6fdbb357-ebdc-43a5-a94d-5d4332813933`;
// // #endregion

// // #region Details about the workspace. Might need revalidation when mutating something about the company.
// // export const WORKSPACE_USER__QUERY_KEY = uniqueUuid`a47af414-fe0b-42d7-8223-4a515ea99073`;
// // export const WORKSPACE_DETAILS__QUERY_KEY = uniqueUuid`dbd47a8e-b7c2-4b3f-a956-6f0b7c2bb4ce`;
// // export const WORKSPACE__ACCESSIBLE_USERS__QUERY_KEY = uniqueUuid`3c5cd16a-28ad-4b79-85fa-4507b0819bf6`;
// export const WORKSPACE__RESOURCE_INFORMATION__QUERY_KEY = uniqueUuid`4e6dcdc4-450d-4798-9043-f97ca2ad4421`;
// export const WORKSPACE__IS_ANOTHER_PLAN_UPCOMING__QUERY_KEY = uniqueUuid`cbecbdf1-f1a5-4db8-bd70-1681bb668188`;
// export const WORKSPACE__CONNECTED_DATA_SOURCES__QUERY_KEY = uniqueUuid`2b99a43a-1b11-4fb2-a0e0-1cc7d568e84c`;
// //#endregion

// // #region Things dealing with localStorage
// export const LOCAL_STORAGE__CONNECTION_ATTEMPTS__QUERY_KEY = uniqueUuid`a62b9c08-f772-440c-9e42-adb76634b69a`;
// // export const LOCAL_STORAGE__ONBOARDING_JOURNEYS__QUERY_KEY = uniqueUuid`5628ef7a-ad58-4828-876f-23a4252d2f23`;
// // #endregion

// // #region Admin thingies
// export const ADMIN__AD_GPT_DATA_SOURCES__QUERY_KEY = uniqueUuid`e4b8455d-95a1-4d0b-850b-f40d71fdadbf`;
// export const ADMIN__ALL_WORKSPACES__QUERY_KEY = uniqueUuid`1f5f00f5-ef66-4196-9362-07e011543a22`;
// export const ADMIN__ALL_USERS__QUERY_KEY = uniqueUuid`0a0bf406-d07f-46ff-9f37-3f52d05d2a17`;
// // #endregion
